import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Router } from '@angular/router';
import { GenericService } from '../generic.service';
import { EnvconfigService } from '../envconfig.service';
import { MenuModel } from 'src/app/core/model/menu.model';
import { environment } from "src/environments/environment";
import { Observable, firstValueFrom } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class SeguridadService extends GenericService<any> {
  // _EnvconfigService :any;
  claims: any = [];
  
  constructor(protected override http: HttpClient,
    private router: Router,
    private _EnvconfigService: EnvconfigService) {
    super(http, "");
  }

  async tokenValido(): Promise<boolean> {
    const helper = new JwtHelperService();
    let _token = localStorage.getItem("access_token")!;
    if (!helper.isTokenExpired(_token)) {
      return true
    }
    else {
      this.cerrarSesion();
      return false;
    }

  }

  async IngresarProducto() {
    //let codigoUsuario: string = <string>this.getCodigoUsuario;
    let codigoUsuario: string = <string>localStorage.getItem(this._EnvconfigService.get("USERCODE"));
    let codigoSistema: string = <string>localStorage.getItem(this._EnvconfigService.get("SISTEMA"));
    const params = new HttpParams()
      .set('CodigoUsuario', codigoUsuario)
      .set('CodigoSistema', codigoSistema);
    return this.http.get(`${this._EnvconfigService.get("apiSUCUrl")}` + '/v2/cuentas-usuarios/ingresar-sistema', { params }).toPromise();
  }

  cerrarSesion() {
    localStorage.clear();
    this.router.navigate(['pagina-401']);
  }

  cerrarSesionInactividad() {
    localStorage.clear();
    this.router.navigate(['pagina-408']);
  }

  /*get getUsuarioRol(): string {
    return localStorage.getItem(this._EnvconfigService.get("ROL")) ?? "";
  }*/

  /*get getIdIFI(): Number {
    return Number(localStorage.getItem(this._EnvconfigService.get("IDIFI")));
  }*/

  get getCodigoIFI(): string {
    return localStorage.getItem(this._EnvconfigService.get("IFICODE")) ?? "";
  }

  ValidarOpcionMenu(strOpcion: string) {
    let _subMenu = JSON.parse(localStorage.getItem(environment.LISTA_SUBMENU)!) as MenuModel[];

    if (!_subMenu.some(item => `/${item.url}` === strOpcion) && strOpcion != '/home/inicio') {

      return false;
    }

    return true;
  }

  setLocalIP() {
    fetch('https://api.ipify.org?format=json')
      .then(response => response.json())
      .then(data => {
        localStorage.setItem('GLOBAL_IP', data.ip)
      })
      .catch(error => {
      });
  }

  async obtenerIPPublica() {
    try {
      const response = await fetch('https://api.ipify.org?format=json');
      const data = await response.json();
      localStorage.setItem('GLOBAL_IP', data.ip);
    } catch (error) {
      localStorage.setItem('GLOBAL_IP', <string>this.getCodigoUsuario);
    }
  }

  getIP() {
    return localStorage.getItem('GLOBAL_IP')
  }

  // getClaims(): Observable<any> {
  //   const token = localStorage.getItem('access_token');

  //   const headers = new HttpHeaders({
  //     'Authorization': `Bearer ${token}`,
  //     'Content-Type': 'application/json'
  //   });
  //   return this.http.get<any>(`${this._EnvconfigService.get("apiURL").trim()}/Seguridad/obtener-token`, { headers });
  // }

  // async decodeToken(): Promise<any> {
  //   try {
  //     const claims = await firstValueFrom(this.getClaims());
  //     this.claims = claims.claims;
  //   } catch (error) {
  //     console.error('Error al obtener datos', error);
  //   }
  // }

  // limpiarClaims(){
  //   this.claims = [];
  // }

  get getIdIFI(): Number {
    //this._EnvconfigService.get("IDIFI") --> trae idIfi
    //const claimIdIfi = this.claims.find(c => c.type === 'IdIfi');
    //return Number(claimIdIfi.value);
    const claimIdIfi = localStorage.getItem(this._EnvconfigService.get('IDIFI'));
    return Number(claimIdIfi);
  }

  get getUsuarioRol(): string {
    //const claimCodigoRol = this.claims.find(c => c.type === this._EnvconfigService.get("ROL"));
    //return claimCodigoRol.value;
    const claimCodigoRol = localStorage.getItem(this._EnvconfigService.get('ROL')) || '';
    return claimCodigoRol;
  }

  get getCodigoUsuario(): string {
    //const claimCodigoUsuario = this.claims.find(c => c.type === this._EnvconfigService.get("USERCODE"));
    //return claimCodigoUsuario.value;
    const claimCodigoUsuario = localStorage.getItem(this._EnvconfigService.get('USERCODE')) || '';
    return claimCodigoUsuario;
  }
}
